<template>
	<div class="newsList-mobile" v-loading="loading">
    <banner></banner>
    <div class="search-wrap">
      <div class="search-key">
        <el-input v-model="searchKey" placeholder="搜索" @keyup.enter="init('key')">
          <template #prefix>
            <el-icon class="el-input__icon" @click="init('key')"><search /></el-icon>
          </template>
        </el-input>
        <div class="search-button" @click="init('key')"><span>搜索</span></div>
      </div>
      <div class="search-classify-button" @click="openDraw"><text class="iconfont" style="font-size:5.3vw">&#xe62b;</text></div>
    </div>
    <div class="news-list">
      <div ref="scrollContainer" class="comm-pd" v-if="pageInfo.count>0">
        <div class="news-item" v-for="(item,index) in articleList" :key="index" @click="jumper(item.id)">
          <div class="news-msg">
            <div class="news-tit">{{item.title}}</div>
            <div class="news-update">{{item.publishDate[0]}}/{{item.publishDate[1]}}/{{item.publishDate[2]}}</div>
          </div>
          <div class="news-img">
            <img :src="commenUrl+item.pictureUrl" alt="" v-if="item.pictureUrl">
            <img src="../../assets/images/newsDefault2.png" alt="" v-else>
          </div>
        </div>
      </div>
      <div class="noData" v-if="noData">
        暂无信息
      </div>
    </div>
    <div class="pagination-box" v-if="pageInfo.count>0">
      <el-pagination
        v-model:current-page="pageInfo.pageNo"
        v-model:page-size="pageInfo.pageSize"
        layout="prev, pager, next, jumper"
        :total="pageInfo.count"
        background
        @current-change="handleCurrentChange"
        small
      >
      </el-pagination>
    </div>
    
      <el-drawer v-model="drawer" :append-to-body="false" direction="btt" resizable class="news-drawer" size="36%">
      
      <template #header="{ close }">
        <div class="title">{{pidCategName}}</div>
        <div type="danger" @click="close">
          <el-icon class="el-icon--left"><CircleCloseFilled /></el-icon>
        </div>
      </template>
      <div class="news-drawer__content">
        <ul>
          <li 
          v-for="item in catgList" 
          :key="item.id" 
          @click="selectArticleId=item.id"
          :class="{'checked':item.id==selectArticleId}">
          <div><span>{{item.categName}}</span></div>
          </li>
        </ul>
      </div>
      <div class="news-drawer__footer">
        <div class="footer-wrap">
          <div style="margin-right:3.73vw;" @click="drawer=false;"><span>取消</span></div>
          <div @click="handleChange(selectArticleId);drawer=false;"><span>确定</span></div>
        </div>
      </div>
    </el-drawer>
  </div>
  
</template>
<script setup>
import {reactive,ref, getCurrentInstance, onMounted, computed,watch} from "vue";
import { Search,Menu,Expand } from '@element-plus/icons-vue'
import { useRouter,useRoute } from 'vue-router';
import banner from '@/components/bannerMobile.vue'
const route=useRoute();
const router=useRouter();
const {proxy}= getCurrentInstance();
function findNodeById(tree, targetId) {
  for (const node of tree) {
    if (node.id === targetId) return node; // 当前节点匹配 
    if (node.children?.length) {
      const found = findNodeById(node.children, targetId); // 递归子节点 
      if (found) return found;
    }
  }
  return null; // 未找到 
}
const catgList=ref([]);
const pidCategName=ref("");
function getClassList(){
  proxy.$request({
    url:"N_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE",
    data:{
      "portalType":"nfstzx",
      "enabledStatus":'1',
      "queryFlag":"1"
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      let obj=findNodeById(res.data.result,pid.value);
      if(obj){
        catgList.value=obj.children?obj.children:[];
        pidCategName.value=obj.categName;
        if(route.query.selectArticleId){
          selectArticleId.value=route.query.selectArticleId
          handleChange(selectArticleId.value);
        }else{
          handleChange(catgList.value[0]?.id);
        }
      }
    }
  }).catch((err)=>{
    console.log(err)
  })
}
const drawer=ref(false);
function openDraw(){
  drawer.value=true;
}
const selectArticleId=ref("")
function handleChange(id) {
  selectArticleId.value = id || "";
  articleClassIds.value = id ? [id] : [];
  pageInfo.pageNo = 1;
  fetchData();
}
// --- 核心方法 ---
const articleClassIds=ref([]);
const pageInfo=reactive({
  pageNo:1,
  pageSize:20,
  count:0,
});
const articleList=ref([]);
const pid=ref(route.query.id);
const searchKey=ref("");
const noData=ref(false);
const loading=ref(false)
const fetchData=()=>{
  loading.value=true
  proxy.$request({
    url:"N_INDUSTRYARTICLEMAGE_FINDPAGELIST",
    data:{
      "articleClassIds":articleClassIds.value,
      "isShow": "0",
      "pageInfo": {
        "pageNo": pageInfo.pageNo,
        "pageSize":pageInfo.pageSize,
      },
      "pidArticleClassId":pid.value,
      "portalType": "nfstzx",
      "search": searchKey.value,
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      res.data.result.list.map(item=>{
        if(item.publishDate)item.publishDate=item.publishDate.split(" ")[0].split('-')
      })
      articleList.value=res.data.result.list;
      pageInfo.count=res.data.result.count;
      noData.value=pageInfo.count=='0'?true:false;
    }
    loading.value=false
  }).catch((err)=>{
    console.log(err);
  });
}

function handleCurrentChange(val){
  pageInfo.pageNo=val;
  fetchData();
}
// --- 生命周期 ---
onMounted(() => {
 init()
});

function init(type){
  pageInfo.pageNo=1;
  catgList.value=[];
  if(type!='key'){
    searchKey.value="";
  }
  getClassList();
}
watch(()=>route.query.id,(newValue,oldValue)=>{
  if(route.query.id){
    pid.value=route.query.id;
    init()
  }
});
function jumper(id){
  router.push({path:'newsDetails',query:{id:id,pid:pid.value}})
}
</script>

<style lang="less">
.newsList-mobile{
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  background: #F7F7F7;
  padding-top: 44px;
  /* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
  @font-face {
    font-family: 'iconfont';  /* Project id 5014541 */
    src: url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff2?t=1757471216125') format('woff2'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff?t=1757471216125') format('woff'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.ttf?t=1757471216125') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';  /* Project id 5014541 */
  }
  .comm-pd{
    padding: 0 4.8vw;
  }
  .noData{
    min-height: 60vh;
    text-align: center;
    
  }
  .ellipsis-multiline{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .search-wrap{
    padding: 0 4.8vw;
    display: flex;
    align-items: center;
    margin-bottom: 3.73vw;
    .search-key{
      flex: 1;
      position: relative;
      .el-input{
        width: 100%;
        height: 8.53vw;
        background: #FFFFFF;
        border-radius:18px;
        overflow: hidden;
        font-size:16px;
        .el-input__wrapper{
          box-shadow:none;
          
        }

      }
      .search-button{
        position: absolute;
        right: 0;
        top: 0;
        width: 14.4vw;
        height: 8.53vw;
        line-height: 8.53vw;
        text-align: center;
        background: #000000;
        border-radius: 0px 18px 18px 0px;
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 3.2vw;
          color: #FFFFFF;
        }
      }
    }
    .search-classify-button{
      width: 5.3vw;
      height: 5.3vw;
      margin-left: 4.8vw;
    }
  }
  .news-list{
    .loading-status {
      padding: 20px;
      text-align: center;
      color: #999;
    }
    .news-item{
      display: flex;
      align-items: center;
      padding: 5.3vw 4.3vw 4.3vw;
      background: #FFFFFF;
      border-radius: 16px;    
      margin-bottom: 2.13vw;
      .news-msg{
        flex: 1;
        .news-tit{
          font-family: AlibabaPuHuiTi_2_95_ExtraBold;
          font-size: 3.5vw;
          color: #1A1A1A;
          line-height: 4.8vw;
          margin-bottom: 2.93vw;
        }
        .news-update{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 3.2vw;
          color: #535353;
          line-height: 4.53vw;
        }
      }
      .news-img{
        width: 27.73vw;
        height: 17.33vw;
        margin-left: 3.5vw;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .el-overlay.is-drawer{
    position: absolute;
  }
  .el-drawer.btt{
    width: 100vw;
  }
  .news-drawer{
    border-radius: 20px 20px 0px 0px;
    .el-drawer__header{
      margin-bottom: 5.3vw;
      padding: 5.3vw 5.3vw 0;
      .title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 3.73vw;
        color: #121212;
      }
    }
    .el-drawer__body{
      padding: 0 5.3vw 17.3vw;
      position: relative;
      
      .news-drawer__content{
        height: 100%;
        overflow-y: scroll;
        ul{
          overflow: hidden;
          li{
            float: left;
            width: 27.2vw;
            height: 7.2vw;
            line-height: 7.2vw;
            text-align: center;
            background: #F5F5F5;
            border-radius: 4px;
            margin-right: 3.73vw;
            margin-bottom:3.73vw;
            div{
              span{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 3.2vw;
                color: #121212;
              }
            }
          }
          li:nth-child(3n){
            margin-right: 0;
          }
          li.checked{
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #121212;
            div{
              span{
                font-weight: 500;
              }
            }
          }
        }
      }
      .news-drawer__footer{
        width: 100%;
        height: 17.33vw;
        background-color: #FFFFFF;
        position: absolute;
        bottom: 0;
        left: 0;
        .footer-wrap{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .footer-wrap>div{
          width: 18.13vw;
          height: 7.47vw;
          line-height: 7.47vw;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #4E4E4E;
          span{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 3.2vw;
            color: #121212;
          }
        }
      }
    }
  }
  .pagination-box{
    display: flex;
    justify-content: center;
    align-items: center;
    .el-pagination.is-background .el-pager li.is-active{
      background-color: #1663FF;
    }
    .el-pagination .btn-prev{
      background-color: #F2F2F2 ;
      color: #595959;
    }
    .el-pagination.is-background .btn-next.is-disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.is-disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.is-disabled, .el-pagination.is-background .el-pager li:disabled{
      background-color: #F2F2F2 ;
      color: #C2C2C2;
    }
    .el-pagination .el-input__inner{
      font-size: 16px;
    }
  }
}
</style>